<template>
  <div class="box">
    <multiselect
      v-model="value"
      :placeholder="placeholder"
      track-by="id"
      :custom-label="customLabel"
      :options="allStores"
      @select="selectedStore">
      <span class="limit">No puede seleccionar más sedes</span>
      <span slot="noResult">No hemos encontrado sedes</span>
      <span slot="noOptions">No hemos encontrado sedes</span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StoreSelect',
  components: {
    Multiselect
  },
  data () {
    return {
      placeholder: 'Todas las sedes',
      value: [],
      stores: [],
      stores: [{'name': 'Todas las sedes', 'id': 999999, 'identifier': ''}]
    }
  },
  mounted: function(){
    this.storesRequest();
  },
  methods: {
    ...mapActions({
      'storesRequest': 'stores/storeRequest'
    }),
    customLabel ({ name, identifier }) {
      return `${name} (${identifier})`
    },
    selectedStore: function(option, id){
      this.placeholder = option.name + " (" + option.identifier + ")"
      this.$emit('storeSelected', option.id, option.identifier)
    }
  },
  computed: {
    allStores: function(){
      this.stores = [{'name': 'Todas las sedes', 'id': '999999', 'identifier': this.getStores.length}]
      this.stores.push(..._.orderBy(this.getStores, ['name', 'identifier'], ['asc', 'asc']))
      return this.stores
    },
    ...mapGetters({
      'getStores': 'stores/allStores'
    })
  },
}
</script>